module.exports = __webpack_public_path__ + "img/share.228757e7.svg";